import apiHandler from "../core/apiHandler";

const supplierDashboardApi = apiHandler('dashboard/suppliers');
export default supplierDashboardApi;
